module.exports = __webpack_public_path__ + "static/media/PC5-1.9b04a009.jpg";